import { useState } from 'react';
import { Outlet } from 'react-router-dom';

import styled from '@emotion/styled';

import HamburgerMenu from './hamburgerMenu/HamburgerMenu';
import { Header } from './header/Header';
import NewFooter from './footer/NewFooter';
import CookieConsentModal from '../components/CookieConsentModal/CookieConsentModal';

const LandingPageLayout = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <HamburgerMenu
        open={open}
        toggleNav={() => {
          setOpen(!open);
        }}
      />
      <Header
        open={open}
        toggleNav={() => {
          setOpen(!open);
        }}
      />
      <Main>
        <Outlet />
      </Main>
      <CookieConsentModal />
      <NewFooter />
    </>
  );
};

export default LandingPageLayout;

const Main = styled.main`
  padding: 1rem 5.4375rem;

  @media (max-width: 884px) {
    padding: 0px 24px;
  }
`;
